import { RouteObject } from'react-router-dom';
import { RequestsDashboard } from'./landing';
import { complaintRoutes } from'./complaint/routes';
import { serviceRoutes } from'./service/routes';
import { disconnectRoutes } from'./disconnect/routes';
import { reconnectRoutes } from'./reconnect/routes';
import { transferRoutes } from'./transfer/routes';

export interface requestsRoute extends Omit<RouteObject,'children'> {
 auth?: boolean;
 children?: requestsRoute[];
}

const createRoutes = [
 ...complaintRoutes,
 ...serviceRoutes,
 ...disconnectRoutes,
 ...reconnectRoutes,
 ...transferRoutes,
].map(route => ({
 ...route,
 path:`/dashboard/requests/${route.path}`,
 auth: false,
}));

export const requestsRoutes: requestsRoute[] = [
 {
 path:'/dashboard/requests',
 element: <RequestsDashboard />,
 auth: false,
 },
 ...createRoutes
];
